import { useClip } from "../../contexts/Clip";
import { useRoot } from "../../contexts/Root";
import { useSeekBar } from "../../contexts/SeekBar";
import { Bar } from "./Bar";

export const ClipBar = () => {
  const {
    theme: { emphasis },
  } = useRoot();
  const { width } = useSeekBar();
  const { show, rangeInPixels } = useClip();

  return (
    <Bar
      show={show}
      offset={rangeInPixels?.start ?? 0}
      width={
        rangeInPixels !== undefined
          ? rangeInPixels.end - rangeInPixels.start
          : width
      }
      zIndex={2}
      color={emphasis}
    />
  );
};
